















































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import {
  BRow, BCol, BFormGroup, BFormInput, BFormSelect, BTabs, BTab,
  BTable, BBadge, BPagination
} from 'bootstrap-vue'
import { PaginatedList } from '@/api/models/common/paginatedList'
import {
  StaffingUtilisateur, StaffingEntreprise, StaffingStatut
} from '@/api/models/staffing/staffing'

@Component({
  components: {
    BRow, BCol, BFormGroup, BFormInput, BFormSelect,
    BTabs, BTab, BTable, BBadge, BPagination
  }
})
export default class StaffingDashboard extends Vue {
  activeTab: 'utilisateurs' | 'entreprises' = 'utilisateurs'
  search = ''
  statutFilter: StaffingStatut | null = null
  pageSize = 25

  pageUtilisateurs = 1
  utilisateurs: PaginatedList<StaffingUtilisateur> = new PaginatedList<StaffingUtilisateur>()
  loadingUtilisateurs = false

  pageEntreprises = 1
  entreprises: PaginatedList<StaffingEntreprise> = new PaginatedList<StaffingEntreprise>()
  loadingEntreprises = false

  utilisateurFields = [
    { key: 'nomComplet', label: 'Utilisateur' },
    { key: 'etpContractuel', label: 'ETP cible' },
    { key: 'etpAlloue', label: 'ETP réel' },
    { key: 'ecart', label: 'Écart' },
    { key: 'statut', label: 'Statut' }
  ]

  entrepriseFields = [
    { key: 'libelle', label: 'Entreprise' },
    { key: 'etpAttendu', label: 'ETP cible' },
    { key: 'etpStaffe', label: 'ETP réel' },
    { key: 'ecart', label: 'Écart' },
    { key: 'statut', label: 'Statut' }
  ]

  statutOptions = [
    { value: null, text: 'Tous' },
    { value: 'sur', text: 'Sur-staffé' },
    { value: 'sous', text: 'Sous-staffé' },
    { value: 'ok', text: 'OK' }
  ]

  async mounted() {
    if (!this.$can('STAFFING:read')) {
      this.$router.replace({ name: 'home' })
      return
    }
    await Promise.all([this.loadUtilisateurs(), this.loadEntreprises()])
  }

  @Watch('search')
  async onSearchChange() {
    await this.refreshAll()
  }

  @Watch('statutFilter')
  async onStatutChange() {
    await this.refreshAll()
  }

  async refreshAll() {
    this.pageUtilisateurs = 1
    this.pageEntreprises = 1
    await Promise.all([this.loadUtilisateurs(), this.loadEntreprises()])
  }

  async loadUtilisateurs() {
    this.loadingUtilisateurs = true
    try {
      this.utilisateurs = await this.$http.myressif.staffing.getStaffingUtilisateurs(
        this.pageUtilisateurs,
        this.pageSize,
        this.search,
        this.statutFilter ?? undefined
      )
    } catch {
      this.utilisateurs = new PaginatedList<StaffingUtilisateur>()
    } finally {
      this.loadingUtilisateurs = false
    }
  }

  async loadEntreprises() {
    this.loadingEntreprises = true
    try {
      this.entreprises = await this.$http.myressif.staffing.getStaffingEntreprises(
        this.pageEntreprises,
        this.pageSize,
        this.search,
        this.statutFilter ?? undefined
      )
    } catch {
      this.entreprises = new PaginatedList<StaffingEntreprise>()
    } finally {
      this.loadingEntreprises = false
    }
  }

  formatEtp(value: number | undefined | null): string {
    if (value == null || isNaN(value)) return '—'
    return Number(value).toFixed(2)
  }

  ecartClass(value: number | undefined | null): string {
    if (value == null) return ''
    if (value > 0.05) return 'text-warning font-weight-bold'
    if (value < -0.05) return 'text-danger font-weight-bold'
    return 'text-success'
  }

  statutLabel(s: StaffingStatut): string {
    if (s === 'sur') return 'Sur-staffé'
    if (s === 'sous') return 'Sous-staffé'
    return 'OK'
  }

  badgeVariant(s: StaffingStatut): string {
    if (s === 'sur') return 'light-warning'
    if (s === 'sous') return 'light-danger'
    return 'light-success'
  }

  goToUtilisateur(id: string) {
    this.$router.push({ name: 'edit-utilisateur', params: { id } })
  }

  goToEntreprise(id: string) {
    this.$router.push({ name: 'details-adherent', params: { id } })
  }
}
